import React from 'react';
import { Route } from 'react-router-dom';
import { PASSINGS_PATH } from './paths';
import Passings from 'modules/Passings/Passings';
function PassingsRoute() {
  return /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: PASSINGS_PATH
  }, /*#__PURE__*/React.createElement(Passings, null));
}
export default PassingsRoute;